module.exports = __webpack_public_path__ + "static/media/bank.9626d397.png";